var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgConvector = function SvgConvector(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M6.31 1.32H26a3.86 3.86 0 0 1 3.847 3.846v19.68A3.86 3.86 0 0 1 26 28.691H6.31a3.86 3.86 0 0 1-3.847-3.845V5.166a3.86 3.86 0 0 1 3.848-3.845zm3.367 28.044c.577 0 1.1.248 1.484.673.165.179.302.399.412.646h-.096a2.6 2.6 0 0 0-.385-.59 1.92 1.92 0 0 0-1.415-.633c-.55 0-1.058.234-1.415.632a2.2 2.2 0 0 0-.385.59h-.096a2.1 2.1 0 0 1 .412-.645 1.98 1.98 0 0 1 1.484-.673m12.806 0c.577 0 1.099.248 1.484.673.165.179.316.399.412.646h-.096a2.2 2.2 0 0 0-.385-.59 1.9 1.9 0 0 0-1.415-.633c-.55 0-1.045.234-1.416.632-.15.165-.274.371-.37.59h-.11c.11-.246.247-.466.426-.645a1.93 1.93 0 0 1 1.47-.673"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M24.448 7.79H8.358V10m16.09 4.065H8.358v2.198m16.09 4.463H8.358v2.197"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConvector);
export default ForwardRef;